import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { calculateTextColor } from "@/helpers/suggestedColors";

type prop = {
  color: string;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as {
  color: string;
}


const color = calculateTextColor(props.color);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "colors",
    style: _normalizeStyle({
      background: props.color,
      color: _unref(color),
    })
  }, null, 4))
}
}

})